import { render, staticRenderFns } from "./Radiology.vue?vue&type=template&id=83b1c7a2"
import script from "./Radiology.vue?vue&type=script&lang=js"
export * from "./Radiology.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports